import { useEffect, useRef } from 'react';

export function useDispatchOnce(cb: () => void) {
  const hasExecuted = useRef(false);

  useEffect(() => {
    if (!hasExecuted.current && cb) {
      hasExecuted.current = true;
      cb();
    }
  }, [cb]);

  return null;
}
